import moment from "moment";
import { loaderSet } from "../../context/actions/loaderAction";
import { getAllSchemePortfolioData, getAllSchemeSectorAllocationData, getSchemePortfolioDataByFilter, getSchemeSectorAllocationDataByFilter } from "../../utils/util";
import {
  color,
  fontStyle,
  letterSpacing,
  margin,
  padding,
  spacing,
  style,
  width,
} from "@mui/system";
import React, { useEffect, useState } from "react";

import { Chart } from "react-google-charts";
import { PiStarFourFill } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
const Portfolio = ({selectedSchemeOptions,footer=true}) => {
  const [schemePortfolioData,setSchemePortfolioData]=useState()
  const [schemeSectorAllocationData,setSchemeSectorAllocationData]=useState()
  const dispatch=useDispatch()
  // const handleGetAllSchemePortfolioData=async()=>{
  //   try {
  //     const response=await getAllSchemePortfolioData()
  //     console.log("Response for handleGetAllSchemePortfolioData function",response)
  //   } catch (error) {
  //     console.log("Errorn in handleGetAllSchemePortfolioData function",error)
  //   }
  // }

  // const handleGetAllSchemeSectorAllocationData=async()=>{
  //   try {
  //     const response=await getAllSchemeSectorAllocationData()
  //     console.log("Response for handleGetAllSchemeSectorAllocationData function",response)
  //   } catch (error) {
  //     console.log("Errorn in handleGetAllSchemeSectorAllocationData function",error)
  //   }
  // }

  // const handleGetSchemePortfolioDataByFilter=async()=>{
  //   dispatch(loaderSet(true))
  //   // const payload={
  //   //   scheme_name:"Vasuki India",
  //   //   scheme_class:"A"
  //   // }
  //   const payload={
  //     scheme_name: selectedSchemeOptions && selectedSchemeOptions.length>0 ? selectedSchemeOptions[0]?.split("-")[0] : "Vasuki India Fund",
  //     scheme_class: selectedSchemeOptions && selectedSchemeOptions.length>0 ? selectedSchemeOptions[0].split("-")[1] : "A"
  //   }
  //   try {
  //     const response=await getSchemePortfolioDataByFilter(payload)
  //     console.log("Response for handleGetSchemePortfolioDataByFilter ",response)
  //     if(response){
  //       setSchemePortfolioData(response?.data[0])
  //     }
  //     dispatch(loaderSet(false))
  //   } catch (error) {
  //     console.log("Error in handleGetSchemePortfolioDataByFilter function",error)
  //     dispatch(loaderSet(false))
  //   }

  // }

  // const handleGetSchemeSectorAllocationDataByFilter=async()=>{
  //   dispatch(loaderSet(true))
  //   const payload={
  //     scheme_name: selectedSchemeOptions && selectedSchemeOptions.length>0 ? selectedSchemeOptions[0]?.split("-")[0] : "Vasuki India Fund",
  //     scheme_class: selectedSchemeOptions && selectedSchemeOptions.length>0 ? selectedSchemeOptions[0].split("-")[1] : "A"
  //   }
  //   try {
  //     const response=await getSchemeSectorAllocationDataByFilter(payload)
  //     console.log("Response for handleGetSchemeSectorAllocationDataByFilter ",response)
  //     if(response){
  //       setSchemeSectorAllocationData(response?.data[0])
  //     }
  //     dispatch(loaderSet(false))
  //   } catch (error) {
  //     console.log("Error in handleGetSchemeSectorAllocationDataByFilter function",error)
  //     dispatch(loaderSet(false))
  //   }

  // }

  // useEffect(()=>{
  //   handleGetSchemeSectorAllocationDataByFilter()
  //   handleGetSchemePortfolioDataByFilter()
  //   handleGetAllSchemeSectorAllocationData()
  //   handleGetAllSchemePortfolioData()
  // },[selectedSchemeOptions])


  // const holdings = [

  //   { name: "Hindustan Aeronautics Limited", percentage: "20.53%" },
  //   { name: "Bharat Electronics Ltd.", percentage: "17.40%" },
  //   { name: "Solar Industries India Ltd.", percentage: "8.27%" },
  //   { name: "Astra Microwave Products Ltd.", percentage: "6.58%" },
  //   { name: "BEML Limited", percentage: "6.37%" },
  //   { name: "MTAR Technologies Limited", percentage: "5.88%" },
  //   { name: "Premier Explosives Ltd.", percentage: "5.08%" },
  //   { name: "CYIENT DLM LIMITED", percentage: "4.91%" },
  //   { name: "InterGlobe Aviation Ltd.", percentage: "4.18%" },
  //   { name: "The Anup Engineering Limited", percentage: "1.87%" },
  // ];

  const investorInfo=useSelector(state=>state.investorInfo)

 function formatDate(dateString, fallback = 0) {
    if (!dateString) return fallback;
  
    // Try parsing ISO format or other recognized formats
    let parsedDate = moment(dateString, moment.ISO_8601, true);
  
    if (!parsedDate.isValid()) {
      // Fallback to parsing "DD.MM.YYYY" format
      parsedDate = moment(dateString, "DD.MM.YYYY", true);
    }
    if (!parsedDate.isValid()) {
      // Fallback to parsing "DD.MM.YYYY" format
      parsedDate = moment(dateString, "DD-MM-YYYY", true);
    }
  
    if (!parsedDate.isValid()) {
      // Fallback to parsing "DD MMM YYYY" format (e.g., "01 Jan 2020")
      parsedDate = moment(dateString, "DD MMM YYYY", true);
    }
  
    if (!parsedDate.isValid()) {
      // Fallback to JavaScript Date object for other formats
      const jsDate = new Date(dateString);
      if (!isNaN(jsDate.getTime())) {
        parsedDate = moment(jsDate);
      }
    }
  
    // Return formatted date in "DD MMM YYYY" format or fallback if invalid
    return parsedDate.isValid() ? parsedDate.format("DD MMM YYYY") : fallback;
  }
  
  // const allSchemeDetails = useSelector(state => state.allSchemeDetails);
  const allSchemeDetails = useSelector(state => state.schemeInfoAgainstInvestor);
  useEffect(() => {
    if (selectedSchemeOptions && selectedSchemeOptions.length > 0 && allSchemeDetails && allSchemeDetails.length > 0) {
      const schemeName = selectedSchemeOptions[0]?.split("-")[0];
      const schemeClass = selectedSchemeOptions[0]?.split("-")[1];
  
      const innerBlockSchemePortfolioAndSectoralAllocation = allSchemeDetails.filter((overviewData) => (
        overviewData.scheme_name === schemeName && overviewData.scheme_class === schemeClass
      ));
  
      setSchemePortfolioData(innerBlockSchemePortfolioAndSectoralAllocation[0])
      setSchemeSectorAllocationData(innerBlockSchemePortfolioAndSectoralAllocation[0])
      // You can now use innerBlockSchemeOverviewData for further actions
      console.log("setSchemeFundPerformanceData(innerBlockSchemeOverviewData)",innerBlockSchemePortfolioAndSectoralAllocation);
            // console.log("schemeSectorAllocationData(schemeSectorAllocationData)",schemeSectorAllocationData);

    }
  }, [selectedSchemeOptions, allSchemeDetails]);
  
  const holdings = schemePortfolioData?.Portfolio
  ?.filter(item => item?.holding_name && item?.holding !== undefined && item?.holding !== null && item?.holding !== "")
  .map((item, index) => ({
    name: item.holding_name,
    percentage: item.holding,
    as_on_date:item.as_on_date,
  }));

  const data = [
    ["Sectoral Allocation", "percentage"], // Header row
    ...(schemeSectorAllocationData?.sectoral_wise_allocation?.length
      ? schemeSectorAllocationData.sectoral_wise_allocation
          // .sort((a, b) => b.holding - a.holding) // Sort by holdings in descending order
          // .slice(0, 10) // Get the top 10 holdings
          .map((item) => [item.sector_name, parseFloat((item.holding * 100).toFixed(2))]) // Map and round the holding values
      : []) // Empty array if no data is available
  ];
  
  

useEffect(()=>{
  console.log("sector allocation data",data,holdings)
},[schemeSectorAllocationData])

  const options = {
    sliceVisibilityThreshold: 0, // Show all small slices
    pieSliceText: "percentage", // Ensure values are displayed
      // pieSliceTextPosition: "outside",  // Move percentage text outside the slices
    pieSliceTextStyle: {
      fontSize: 14, // Increase text size for better visibility
      color: "black",
      fontWeight:"bold"
    },
    // is3D: true,
    legend: {
      position: "right",
      alignment: "center", // Center-aligns the legend items vertically
      maxLines: 15, // Increases the number of lines displayed (if needed)
      textStyle: {
        color: "#233238",
        fontSize: 15, // Adjust font size to fit legend items better
      },
    },
    chartArea: {
      width: "100%",
      height: "70%",
    },
   colors : [
      '#FF6384', // Red
      '#36A2EB', // Blue
      '#FFCE56', // Yellow
      '#4BC0C0', // Teal
      '#9966FF', // Purple
      '#FF9F40', // Orange
      '#66FF66', // Green
      '#FF66B2', // Pink
      '#3399FF', // Light Blue
      '#FFCC99',  // Peach
      '#c9cbcf',
      '#e67c73'       
    ]
  };

  return (
    <div>
      <section aria-labelledby="portfolio-section-heading">
        <div className=" bg-white mb-12">
          <h2 id="portfolio-section-heading" className="text-2xl mt-6 font-bold bg-[#0E2841] text-white py-3 pl-2 rounded-sm mb-2">
            Portfolio
          </h2>
          <p className="mb-4 text-gray-700 font-medium">
            Portfolio details as on {holdings && holdings.length>0 && formatDate(holdings[0]?.as_on_date)}
          </p>
          {!holdings || holdings.length === 0 ? (
            <p className="mb-4 text-slate-700" role="status" aria-live="polite">No portfolio holdings data available for the selected scheme.</p>
          ) : null}
          <h3 className="text-lg font-medium  mb-2">Top 10 Holdings</h3>
          <div className="border border-gray-800  mb-8 "></div>
          <div className="grid grid-cols-2 gap-8">
            <div>
              { holdings && holdings.length>0 &&  holdings.slice(0, 5).map((holding, index) => (
                <div key={index} className="">
                  <div className="flex flex-row mb-2 gap-4 justify-between">
                    <span className="flex flex-row items-center gap-2">
                      {" "}
                      <div className="rounded-full bg-blue-200 p-1 text-blue-800">
                        <PiStarFourFill className="" />
                      </div>
                      <div className="text-[#0D215C] font-semibold">
                        {holding.name}
                      </div>
                    </span>
                    <span className="text-[#0D215C] font-semibold">
                      {holding.percentage}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div>
              { holdings && holdings.length>0 &&  holdings.slice(5, 10).map((holding, index) => (
                <div key={index} className="">
                  <div className="flex flex-row mb-2 gap-4 justify-between">
                    <span className="flex flex-row items-center gap-2">
                      {" "}
                      <div className="rounded-full bg-blue-200 p-1 text-blue-800">
                        <PiStarFourFill className="" />
                      </div>
                      <div className="text-[#0D215C] font-semibold">
                        {holding.name}
                      </div>
                    </span>
                    <span className="text-[#0D215C] font-semibold">
                      {holding.percentage}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section aria-labelledby="sector-allocation-heading">
        <h3 id="sector-allocation-heading" className="text-2xl mt-6 font-bold bg-[#0E2841] text-white py-3 pl-2 rounded-sm mb-4">
          Sectoral Allocation
        </h3>
       <div className= " w-full flex items-center justify-center " >
       <Chart
          chartType="PieChart"
          data={data}
          width={"100%"}
          height={"600px"}
          className="font-medium "
          options={options}
        />
       </div>
      </section>
      { footer && <p className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2">Note: Please reach out to us at <a href="mailto:vasuki.compliance@vasukiindia.com" className="text-blue-700 underline font-normal" aria-label="Email Vasuki Compliance">vasuki.compliance@vasukiindia.com</a> for more details
        </p>}
      <p  className="text-2xl mt-6 font-bold   py-3 pl-2 rounded-sm mb-2" ></p>
    
    </div>
  );
};

export default Portfolio;
